module.exports = __webpack_public_path__ + "static/involve-934f787ff853da01d4a50629851ab8c6.png";